import { EventProperty } from "@/types";

export function getShortDescriptionFromEventProperties<T extends EventProperty>(
  properties: T[]
): T | undefined {
  return properties.find(
    (eventTypeProperty) => eventTypeProperty.type === "text"
  );
}
